import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

const EXCLUDED_SIGNAL_TYPES: readonly SignalType[] = [
    SignalType.Apps,
    SignalType.AdvertiserActivity,
    SignalType.RoleChanges,
];

export const filterSignalTypes = (signalTypes: readonly SignalType[]) => {
    const withoutExcluded = signalTypes.filter((signalType: SignalType) => !EXCLUDED_SIGNAL_TYPES.includes(signalType));

    if (!salesSettingsHelper.isSalesApiSignalsIntentEnabled) {
        return withoutExcluded.filter((signalType: SignalType) => signalType !== SignalType.Intent);
    }

    return withoutExcluded;
};
